"use client";

import classNames from "classnames";
import PAText from "component/design-system/typography/PAText/PAText";
import PropTypes from "prop-types";
import { Component } from "react";
import createChainedFunction from "./utils/createChainedFunction";

const propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  role: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  eventKey: PropTypes.any,
};

const defaultProps = {
  active: false,
  disabled: false,
};

class NavItem extends Component {
  constructor(props: any, context: any) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: any) {
    if (this.props.onSelect) {
      e.preventDefault();

      if (!this.props.disabled) {
        this.props.onSelect(this.props.eventKey, e);
      }
    }
  }

  render() {
    const {
      active, disabled, onClick, className, style, ...props
    } = this.props;

    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === "#") {
        props.role = "button";
      }
    } else if (props.role === "tab") {
      props["aria-selected"] = active;
    }

    return (
      <li
        role="presentation"
        className={classNames(className, { active, disabled })}
        style={style}
      >
        <PAText
          component={this.props.component || "span"}
          className="m-0"
          onClick={createChainedFunction(onClick, this.handleClick)}
          style={{ cursor: "pointer" }}
          {...props}
          disabled={disabled}
        />
      </li>
    );
  }
}

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

export default NavItem;
